var cart_id = '';
var store = 'uk';
const api_base_url = 'https://api.leestafford.com/';
var texts = {
    qty: 'Qty:',
    apply: 'Apply',
    remove: 'Remove',
};

document.addEventListener('rebuy:cart.add', function(event){
  fetchCart();
  showCartDrawer();
});

document.addEventListener('cart:updated', function(event){
  fetchCart();
});

$('#cart-icon-bubble').click(function(e) {
  e.preventDefault();
  showCartDrawer();
});

$('.cart-drawer-overlay, .cart-drawer .close-btn').click(function(e) {
  e.preventDefault();
  closeCartDrawer();
});

function showCartDrawer() {
  $('.cart-drawer-overlay').fadeIn();
  $('.cart-drawer').addClass('show');
  $('body').css('overflow', 'hidden');
  $('.acsb-trigger, #loyaltylion-beacon-frame, .cmpboxrecall').hide();
  if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
    $('access-widget-ui')[3].shadowRoot.querySelector('button').style.display = 'none';
  }
}

function closeCartDrawer() {
  $('.cart-drawer-overlay').fadeOut();
  $('.cart-drawer').removeClass('show');
  $('body').attr('style', ''); 
  $('.acsb-trigger, #loyaltylion-beacon-frame, .cmpboxrecall').show();
  if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
    $('access-widget-ui')[3].shadowRoot.querySelector('button').style.display = '';
  }
}

function changeItem(line, quantity, callback) { 
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                fetchCart();
                //removeProductFromCart();
            }
        },
        error: function() {
            fetchCart();          
        }
    });
} 

function fetchCart(skipGiftCheck) {
  $('.cart-drawer').addClass('loading');
  $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
          if (cart.item_count === 0) {
            $('#cart-full-state').hide();
            $('#cart-empty-state').show();
            $('.cart-drawer').removeClass('loading');
            $('.cart-count-bubble').hide();
          } else {
            cart_id = cart.token; 
            renderCart(cart);
            $('#cart-full-state').show();
            $('#cart-empty-state').hide();
            $('.cart-count-bubble').show().find('span[aria-hidden="true"]').text(cart.item_count);
            if (!skipGiftCheck) processGifts(cart);
          }
          $('.cartcount').text(cart.item_count);
      },
  });
}

function updateFreeShipping(total, items_types) {
  var $block = $('#fs-cart-block');
  if($block.length === 0) return;
  var goal = parseInt($block.attr('data-goal'))*100;
  var exclude_types = $block.attr('data-exclude-product-types').split(','); 
  if(exclude_types.length > 0) {
  	for(var i in items_types) {
      if(exclude_types.indexOf(items_types[i]) !== -1) {
        $('.free-shipping-progress').hide();
        $('.free-shipping-success').hide();        
        return;
      }
  	}
  } 
  
  if(total>=goal) {
  	$('.free-shipping-progress').hide();
    $('.free-shipping-success').show();
  } else {
  	$('.free-shipping-progress').show();
    $('.free-shipping-success').hide();
  	var remaining = Shopify.formatMoney(goal-total, money_format_type);
  	$('#fs-amount').text(remaining);
    var progress = (total/goal) *100;
    $('#fs-bar > div').css('width', progress+'%')
  }
}

function renderCart(cart) {
  var html = '';
  var types = [];
  var vendors = [];
  var variant_ids = [];
  var $upsale_blocks = $('.add-me-to-save'); 
  var upsale_shown = false;
  var check_qty_data = [];

  // Build set of active gift handles from config
  var giftHandles = {};
  var giftMessagesMap = {};
  (window.marq_gifts_config || []).forEach(function(rule) {
    if (rule.active && rule.handle && rule.handle.trim()) {
      giftHandles[rule.handle.trim()] = true;
      giftMessagesMap[rule.handle.trim()] = rule.message || 'Free Gift';
    }
  });
  
  cart.items.forEach(function(item, index) { 
      const productImage = '<figure><a href="'+item.url+'"><img class="image" src="' + item.image + '" ></a></figure>';    
      const productTitle = '<a href="'+item.url+'" class="title">' + item.title + '</a>';

      // Handle gift items (identified by handle from gifts config)
      var isGift = !!giftHandles[item.handle];
      if (isGift) {
        var giftMessage = giftMessagesMap[item.handle] || 'Free Gift';
        var giftHtml = '<div class="cart-item is-gift" data-line="' + Number(index + 1) + '" data-product-id="'+item.product_id+'">' + productImage
          + '<div class="title-column">' + productTitle + '<div class="quant-row"><div class="gift-badge">' + giftMessage + '</div><div class="price gift-price">FREE</div></div></div></div>';
        types.push(item.product_type);
        vendors.push(item.vendor);
        variant_ids.push(item.variant_id);
        html = html + giftHtml;
        return;
      }

      let kitHtml = '';
      if(item.properties && Object.keys(item.properties).length > 0) {
        let isKit = item.product_type === 'Mine Kit' || item.product_type === 'Mine Value Pack';
        if(isKit) {
          let subItems = [];
          for (const property in item.properties) {
            if ((property.startsWith('_selected_main_title_') || property.startsWith('_selected_mist_title_'))
               && item.properties[property] !== '') {
              let title = property.replace('_selected_main_title_', '').replace('_selected_mist_title_', '').replace(/_/g, ' ');
              let img = item.properties[property.replace('title', 'img')];
              subItems.push({ title: item.properties[property], img: img });
            }
          }
          if(subItems.length > 0) {
            kitHtml = '<div class="kit-items">';
            subItems.forEach(function(subItem) {
              kitHtml += '<div class="kit-item"><div class="img-hold"><img src="'+subItem.img+'" /></div><div class="kit-title">'+subItem.title+'</div></div>';
            });
            kitHtml += '</div>';
          }
        }
      }
      if(item.discounts.length>0) {  
        var productPrice = '<div class="price"><div>' +  Shopify.formatMoney(item.final_line_price, money_format_type) + '</div><div class="old-price">' +  Shopify.formatMoney(item.original_line_price, money_format_type) + '</div></div>';
      } else {
        var productPrice = '<div class="price">' +  Shopify.formatMoney(item.line_price, money_format_type) + '</div>';
      }
      var block_qty = (item.vendor == 'Private Label' ? ' block' : '');
      const productQuantity = '<div class="quantity--contain">'+
            '<label for="quantity">'+texts.qty+' </label>'+
            '<div aria-label="Remove 1" class="dec button'+block_qty+'">-</div>'+
            '<input type="text" id="quantity" readonly name="updates[]" data-value="1" value="' + item.quantity + '">'+
			'<div aria-label="Add 1" class="inc button'+block_qty+'">+</div>' +
			'</div>'; 
      const productRemove = '<div class="remove-hold"><div class="remove"></div></div>';

      const concatProductInfo = '<div class="cart-item" data-line="' + Number(index + 1) + '" data-product-id="'+item.product_id+'">' + productImage
      + '<div class="title-column">'+productTitle+ kitHtml +'<div class="quant-row">'+ productQuantity +productRemove+productPrice  + '</div></div>' +
      '</div>';
      types.push( item.product_type );
      vendors.push( item.vendor); 
      variant_ids.push( item.variant_id );
      if(item.vendor == 'Private Label') {
        check_qty_data.push(item.product_id);
      }
      html = html + concatProductInfo; 
  });
  
  if( $upsale_blocks.length>0) {
    $upsale_blocks.each(function() {
      var variant_id = parseInt($(this).attr('data-variant-id'));
      var product_type =  $(this).attr('data-product-type').split(',');
      var vendor =  $(this).attr('data-vendor');
      var common_types = product_type.filter(x => types.indexOf(x) !== -1);
      if(variant_ids.indexOf(variant_id) === -1 && !upsale_shown &&
         ( (vendor !== '' && vendors.indexOf(vendor) !== -1) || (product_type.length>0 && common_types.length>0) ) ) {
        $(this).show();
        upsale_shown = true;
      } else {
        $(this).hide();
      }
    });
  }
  $('#cartDrawerItems').html(html);
  if(check_qty_data.length>0) {
    for(var i in check_qty_data) {
      getQtyData(check_qty_data[i]);
    }
  }
  
  var total = cart.items_subtotal_price;
  $('.cart-content').removeClass('with-discount');
  
  $('#cartDrawerSubtotal').html( Shopify.formatMoney(cart.original_total_price, money_format_type) );
  $('#cartDrawerTotal').html( Shopify.formatMoney(total, money_format_type) );
  
  updateFreeShipping(cart.items_subtotal_price, types, vendors);
  fetchDiscount(cart);
  
  $('.cart-drawer').removeClass('loading');
}

function staticCartInitFreeShipping() {
  if($('.free-shipping.static-cart').length === 0) return;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
          if (cart.item_count != 0) {  
            var types = [];
            var vendors = [];
            cart.items.forEach(function(item, index) {  
                types.push( item.product_type );
                vendors.push( item.vendor); 
            });
            updateFreeShipping(cart.items_subtotal_price, types, vendors);
          } 
      },
  });
}

function getQtyData(product_id) {  
  $.ajax({
      type: 'GET', 
      url: api_base_url + 'metafields-min-qty.php',
      data: 'store='+store+'&id=' + product_id,
      dataType: 'json',
      success: function(response) {
        if(typeof response.success !== 'undefined') { 
          console.log(response.data);
          var $item = $('.cart-item[data-product-id="'+product_id+'"]');
          $item.find('.button.block').removeClass('block');
          var $input = $item.find('#quantity');
          if(response.success) {
            $input.attr('data-value', response.data.step);
            $input.attr('data-min', response.data.min);
          }
        }
      }
  });
}

function initCartQuantityControls() {
 $(document).on("click", "#cartDrawerItems .quantity--contain .button", function(e) {
    e.preventDefault();
    var valInc = $(this).parent().find('#quantity').attr("data-value");
    var oldValue = $(this).parent().find("#quantity").val(),
        newVal = 1;

    if ($(this).text() == "+") {
        newVal = parseInt(oldValue) + parseInt(valInc);
    } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - parseInt(valInc);
    }

    $(this).parent().find('#quantity').attr('value', newVal);
  
    const line = parseInt($(this).closest('.cart-item').attr('data-line')); 
   	changeItem(line, newVal);
  });

  $("#cartDrawerItems .quantity--contain .button").on('click', function(e) {
  	$(this).parent().find('input.update').trigger( "click" ); 
  });
} 

function initDiscountField() {
  $('#cart-discount-field').keyup(function(e) {
    var code = e.key; 
    if($('#cart-promocode-error').length>0) $('#cart-promocode-error').remove();
    if(code==="Enter") {
      e.preventDefault();
      applyDiscount( $(this).val() );
    }
  });
  $('#cart-apply-discount').click(function(e) {
    e.preventDefault(); 
    if(!$('#cart-discount-field').attr('readonly')) {
      applyDiscount( $('#cart-discount-field').val() );
    } else {
      removeDiscount();
    }
  });
}

function fetchDiscount(cart) { 
  var discount_cart_data = null;
  
  for(var i in cart.items) {
    if(cart.items[i].line_level_discount_allocations.length>0) {
      for(var j in cart.items[i].line_level_discount_allocations) {
        if(cart.items[i].line_level_discount_allocations[j].discount_application.type == 'discount_code') {
          discount_cart_data = cart.items[i].line_level_discount_allocations[j].discount_application;
          break;
        }
      }
    }
  }  
  
  if(discount_cart_data) {
  	$('#cart-discount-field').val(discount_cart_data.title);
    $('#cart-discount-field').attr('readonly', true);
    $('#cart-apply-discount').text(texts.remove);
    
    $('.cart-content').addClass('with-discount');  
    $('#cartDrawerDiscount').html( '-'+Shopify.formatMoney(cart.total_discount, money_format_type) );
  } else {
  	$('#cart-discount-field').val('');
    $('#cart-discount-field').attr('readonly', false);
  	$('#cart-apply-discount').text(texts.apply);
    
    $('.cart-content').removeClass('with-discount');  
    $('#cartDrawerDiscount').html('');
  } 
}

function applyDiscount(code) { 
  $.ajax({
      type: 'GET', 
      url: api_base_url + 'promocode.php',
      data: 'store='+store+'&promocode=' + code+'&version=2&cart_id='+cart_id,
      dataType: 'json',
      success: function(response) {
        if(typeof response.success !== 'undefined' && !response.success) {
          if($('#cart-promocode-error').length>0) $('#cart-promocode-error').remove();
          $('.cart-promocode-form').append('<div class="error" id="cart-promocode-error">'+response.error+'</div>');          
        } else { 
          $('#cart-discount-field').attr('readonly', true);
          $('#cart-apply-discount').text(texts.remove);       
          $('#cart-promocode-error').remove();
          
          if($('.free-shipping.static-cart').length === 0) {
  		      fetchCart();
          } else {
            window.location.reload();
          }
        }
      }
  });
}

function removeDiscount() {
   $.ajax({
      type: 'GET', 
      url: api_base_url + 'promocode.php',
      data: 'store='+store+'&promocode=&version=2&cart_id='+cart_id,
      dataType: 'json',
      success: function(response) { 
        $('#cart-discount-field').val('');
        $('#cart-discount-field').attr('readonly', false);
        $('#cart-apply-discount').text(texts.apply);
        if($('.free-shipping.static-cart').length === 0) {
          fetchCart();
        } else {
          window.location.reload();
        }
      }
   });
}

function setCookie(name,value,minutes) {
  var expires = "";
  if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + (minutes*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function initUpsaleItems() {  
  $('.add-me-to-save').each(function() {
    if( getCookie('dismiss_offer_'+$(this).data('id')) ) {
      $(this).remove();
    }
  });
  $(document).on('click', '.add-me-to-save .dismiss', function(e) {
    e.preventDefault();
    var offer = $(this).closest('.add-me-to-save');
    setCookie('dismiss_offer_'+offer.attr('data-id'), true, 20);
    offer.remove();
  });
  
  $(document).on('click', '.add-upsale-item', function(e) {
    e.preventDefault();
    var variant_id = $(this).attr('data-variant-id');
    $.ajax({	
		type: "post",	
        url: "/cart/add.js",	
        data: "quantity=1&id=" + variant_id,	
        dataType: "json" ,
        success: function() {
  			fetchCart();                  
        }
    });
  });
}
 
function processGifts(cart) {
  var giftRules = window.marq_gifts_config || [];
  if (!giftRules.length) return;

  // Build set of all gift handles from config
  var allGiftHandles = {};
  giftRules.forEach(function(rule) {
    if (rule.handle && rule.handle.trim()) allGiftHandles[rule.handle.trim()] = true;
  });

  // Separate non-gift items (identified by handle)
  var nonGiftItems = [];
  cart.items.forEach(function(item) {
    if (!allGiftHandles[item.handle]) {
      nonGiftItems.push(item);
    }
  });

  function parseCsvList(value) {
    return value ? value.split(',').map(function(s) { return s.trim(); }).filter(function(s) { return s; }) : [];
  }

  function parseHandleTriggerGroups(value) {
    return value
      ? value.split(',').map(function(group) {
          return group.split('+').map(function(s) { return s.trim(); }).filter(function(s) { return s; });
        }).filter(function(group) { return group.length > 0; })
      : [];
  }

  // Returns qualifying item count for a rule, or 0 if rule doesn't qualify.
  // Mirrors the app's AND logic across filter types.
  function checkRuleQualifies(rule, giftHandle) {
    var triggerHandleGroups = parseHandleTriggerGroups(rule.with_product_handle);
    var triggerHandlesSet = {};
    triggerHandleGroups.forEach(function(group) {
      group.forEach(function(h) { triggerHandlesSet[h] = true; });
    });
    var triggerProductTypes = parseCsvList(rule.product_type);
    var triggerVendors = parseCsvList(rule.product_vendor);

    var noTriggersSpecified = triggerHandleGroups.length === 0 &&
                               triggerProductTypes.length === 0 &&
                               triggerVendors.length === 0;

    var qualifyingItemsCount = 0;

    if (noTriggersSpecified) {
      nonGiftItems.forEach(function(item) {
        if (item.handle !== giftHandle) qualifyingItemsCount += item.quantity;
      });
    } else {
      // AND across filter types: all specified must be satisfied
      var productTypeRequirementMatched = triggerProductTypes.length === 0;
      var vendorRequirementMatched = triggerVendors.length === 0;
      var matchedTriggerHandles = {};
      var nonGiftNonSelfItems = [];

      nonGiftItems.forEach(function(item) {
        if (item.handle === giftHandle) return;
        nonGiftNonSelfItems.push(item);

        if (triggerHandlesSet[item.handle]) {
          matchedTriggerHandles[item.handle] = true;
        }
        if (triggerProductTypes.length > 0 && triggerProductTypes.indexOf(item.product_type) !== -1) {
          productTypeRequirementMatched = true;
        }
        if (triggerVendors.length > 0 && triggerVendors.indexOf(item.vendor) !== -1) {
          vendorRequirementMatched = true;
        }
      });

      var satisfiedHandleGroups = triggerHandleGroups.filter(function(group) {
        return group.every(function(handle) { return matchedTriggerHandles[handle]; });
      });

      // All specified filter types must pass (AND)
      if (triggerHandleGroups.length > 0 && satisfiedHandleGroups.length === 0) return 0;
      if (!productTypeRequirementMatched) return 0;
      if (!vendorRequirementMatched) return 0;

      // Count qualifying items
      if (satisfiedHandleGroups.length > 0) {
        var satisfiedHandleSet = {};
        satisfiedHandleGroups.forEach(function(group) {
          group.forEach(function(h) { satisfiedHandleSet[h] = true; });
        });
        nonGiftNonSelfItems.forEach(function(item) {
          if (satisfiedHandleSet[item.handle]) {
            qualifyingItemsCount += item.quantity;
          }
        });
      } else {
        nonGiftNonSelfItems.forEach(function(item) {
          var matchesType = triggerProductTypes.length > 0 && triggerProductTypes.indexOf(item.product_type) !== -1;
          var matchesVendor = triggerVendors.length > 0 && triggerVendors.indexOf(item.vendor) !== -1;
          if (matchesType || matchesVendor) {
            qualifyingItemsCount += item.quantity;
          }
        });
      }
    }

    if (qualifyingItemsCount === 0) return 0;

    // Check minimum order amount against non-gift cart total
    if (rule.by_order_amount && rule.by_order_amount > 0) {
      var nonGiftTotal = 0;
      nonGiftItems.forEach(function(item) {
        nonGiftTotal += item.final_line_price;
      });
      if (nonGiftTotal < rule.by_order_amount * 100) return 0;
    }

    return qualifyingItemsCount;
  }

  var giftsToAdd = [];
  var giftLinesToRemove = [];

  giftRules.forEach(function(rule) {
    if (!rule.active) return;
    if (!rule.handle || !rule.handle.trim()) return;

    var giftHandle = rule.handle.trim();
    var qualifies = checkRuleQualifies(rule, giftHandle) > 0;

    // Find gift in cart by handle
    var giftInCart = null;
    cart.items.forEach(function(item) {
      if (item.handle === giftHandle) giftInCart = item;
    });

    if (qualifies && !giftInCart) {
      giftsToAdd.push(rule);
    }
  });

  // Check for gift items that should be removed (no longer qualifying)
  cart.items.forEach(function(item, index) {
    if (!allGiftHandles[item.handle]) return;
    var stillQualifies = false;
    giftRules.forEach(function(rule) {
      if (!rule.active || rule.handle !== item.handle) return;
      if (checkRuleQualifies(rule, item.handle) > 0) stillQualifies = true;
    });
    if (!stillQualifies) {
      giftLinesToRemove.push(index + 1);
    }
  });

  // Remove gifts already in cart from add list
  giftsToAdd = giftsToAdd.filter(function(rule) {
    var found = false;
    cart.items.forEach(function(item) {
      if (item.handle === rule.handle.trim()) found = true;
    });
    return !found;
  });

  if (giftsToAdd.length === 0 && giftLinesToRemove.length === 0) return;

  $('.cart-drawer').addClass('loading');

  function processRemoves(callback) {
    if (giftLinesToRemove.length === 0) { callback(); return; }
    giftLinesToRemove.sort(function(a, b) { return b - a; });
    var line = giftLinesToRemove.shift();
    $.ajax({
      type: 'POST', url: '/cart/change.js',
      data: 'quantity=0&line=' + line,
      dataType: 'json',
      success: function() { processRemoves(callback); },
      error: function() { processRemoves(callback); }
    });
  }

  function processAdds(callback) {
    if (giftsToAdd.length === 0) { callback(); return; }
    var rule = giftsToAdd.shift();
    $.getJSON('/products/' + rule.handle + '.js', function(product) {
      if (product && product.variants && product.variants.length > 0 && product.variants[0].available) {
        $.ajax({
          type: 'POST', url: '/cart/add.js',
          data: JSON.stringify({ quantity: 1, id: product.variants[0].id }),
          contentType: 'application/json',
          dataType: 'json',
          success: function() { processAdds(callback); },
          error: function() { processAdds(callback); }
        });
      } else {
        processAdds(callback);
      }
    }).fail(function() { processAdds(callback); });
  }

  processRemoves(function() {
    processAdds(function() {
      fetchCart(true);
    });
  });
}

$(document).ready(function() {
  fetchCart();
  initCartQuantityControls(); 
  initDiscountField();
  initUpsaleItems();
  staticCartInitFreeShipping();
});

$(document).on('click', '.cart-drawer .cart-item .remove', function(e) {
  e.preventDefault();
  const line = parseInt($(this).closest('.cart-item').attr('data-line')); 
  changeItem(line, 0);
});